"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elevationHighestOndark = exports.elevationHighestOnlight = exports.elevationHighOndark = exports.elevationHighOnlight = exports.elevationLowOndark = exports.elevationLowOnlight = exports.focusDanger = exports.focusEnabled = exports.baseFocusDangerInverse = exports.baseFocusDanger = exports.baseFocusDefaultInverse = exports.baseFocusDefault = exports.baseElevationHighest = exports.baseElevationHigh = exports.baseElevationLow = void 0;
exports.baseElevationLow = '0px 2px 8px 0px #1616167a';
exports.baseElevationHigh = '0px 4px 12px 0px #161616a3';
exports.baseElevationHighest = '0px 8px 16px 0px #161616';
exports.baseFocusDefault = {
  borderWidth: 1,
  borderColor: '#8FB3E9',
  boxShadow: '0px 0px 0px 4px #8fb3e966'
};
exports.baseFocusDefaultInverse = {
  borderWidth: 1,
  borderColor: '#242424',
  boxShadow: '0px 0px 0px 4px #8fb3e966'
};
exports.baseFocusDanger = {
  borderWidth: 1,
  borderColor: '#EC8086',
  boxShadow: '0px 0px 0px 4px #ec808666'
};
exports.baseFocusDangerInverse = {
  borderWidth: 1,
  borderColor: '#242424',
  boxShadow: '0px 0px 0px 4px #ec808666'
};
exports.focusEnabled = '0px 0px 0px 4px #8fb3e966';
exports.focusDanger = '0px 0px 0px 4px #ec808666';
exports.elevationLowOnlight = '0px 2px 8px 0px #16161614';
exports.elevationLowOndark = '0px 2px 8px 0px #1616167a';
exports.elevationHighOnlight = '0px 2px 16px 0px #1616161f';
exports.elevationHighOndark = '0px 4px 12px 0px #161616a3';
exports.elevationHighestOnlight = '0px 4px 24px 0px #16161629';
exports.elevationHighestOndark = '0px 8px 16px 0px #161616';